
import metadataMixin from '@/mixins/metadataMixin';
import renewAuthTokenMixin from '@/mixins/renewAuthToken.mixin';
import { mapState } from 'vuex';

export default {

    components: {
        VueOffers: () => (process.client ? import('@justeat/f-offers') : null)
    },

    mixins: [
        metadataMixin,
        renewAuthTokenMixin
    ],

    layout: 'offers',

    computed: {
        ...mapState('configuration', [
            'settings'
        ]),

        ...mapState('auth', [
            'authToken',
            'isAuthFinished'
        ]),

        brazeApiKey () {
            return this.settings.braze.apiKey;
        }
    }
};
